class CsrfStore {
	private token: string = '';

	public get(): string {
		return this.token;
	}

	public set(newToken: string): void {
		this.token = newToken;
	}
}

const csrfStore = new CsrfStore();
export default csrfStore;
